// TeamMembers.jsx
import React, { useEffect } from 'react';
import './Team.css';
import male from '../../images/male-ceo.jpg';
import female from '../../images/female-ceo.jpg';

import director from '../../images/team/director.jpg';
import creativeOfficer from '../../images/team/creative officer.jpg';
import influencer from '../../images/team/influencer.jpg';
import developer from '../../images/team/developer.jpg';
import creativeSpecialist from '../../images/team/Creative Specialist.jpg';
import operationsOfficer from '../../images/team/Operations Officer.jpg';

const Team = () => {

  // Team members data array
  const teamData = [
    {
      id: 1,
      name: "Ifeanyichukwu Omali",
      position: "Director",
      image: director,
      rating: 5
    },
    {
      id: 2,
      name: "Nwafor Joan",
      position: "Chief Creative Officer",
      image: creativeOfficer,
      rating: 5
    },
    {
      id: 3,
      name: "Harriet Ejegi",
      position: "Brand Influencer",
      image: influencer,
      rating: 5
    },
    {
      id: 4,
      name: "Onajite Ika",
      position: "Creative Specialist",
      image: creativeSpecialist,
      rating: 5
    },
    {
      id: 5,
      name: "Emmanuel Olajide",
      position: "Operations Officer",
      image: operationsOfficer,
      rating: 5
    },
    {
      id: 6,
      name: "John Joseph",
      position: "Web Developer",
      image: developer,
      rating: 5
    },
  ];

  return (
    <section className="team">
      <div className="team__container">
        <div className="team__header">
          <div className="team__badge">
            Our Team <span className="team__badge-icon">↗</span>
          </div>
          <h2 className="team__title">
            Our Expert Team Member
          </h2>
          <p className="team__subtitle">
            Meet our skilled team, delivering innovative solutions and exceptional results
          </p>
        </div>

        <div className="team__grid">
          {teamData.map((member, index) => (
            <div 
              className="team__card" 
              key={member.id}
            >
              <div className="team__image-container">
                <img 
                  src={member.image} 
                  alt={member.name} 
                  className="team__image" 
                />
              </div>
              <div className="team__rating">
                {[...Array(member.rating)].map((_, i) => (
                  <span key={i} className="team__star">★</span>
                ))}
              </div>
              <div className="team__content">
                <h3 className="team__name">{member.name}</h3>
                <p className="team__position">{member.position}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;